import React from 'react';
import AdminReviewCardForm from '../../../components/admin/reviewCard/AdminReviewCardForm';

const AdminReviewCard = () => {
  return (
    <div className='w-full h-full flex items-center justify-center'>
      <AdminReviewCardForm />
    </div>
  );
};

export default AdminReviewCard;
